"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useWishlist = void 0;
const app_1 = require("@obvio/app");
const WISHLIST_SELECT = {
    id: true,
    slug: true,
    title: true,
    images: true,
    price: {
        price: true,
    },
};
function useWishlist() {
    var _a;
    const { data, loading } = (0, app_1.useQuery)('getWishlist', {
        select: { products: WISHLIST_SELECT },
    });
    const [addToWishlist] = (0, app_1.useMutation)('addToWishlist', {
        refetchQueries: ['getWishlist'],
    });
    const [removeFromWishlist] = (0, app_1.useMutation)('removeFromWishlist', {
        refetchQueries: ['getWishlist'],
    });
    return {
        products: (_a = data === null || data === void 0 ? void 0 : data.products) !== null && _a !== void 0 ? _a : [],
        addToWishlist,
        removeFromWishlist,
        loading,
    };
}
exports.useWishlist = useWishlist;
